export const FEATURED_TOOL_LINKS = [
  {
    slug: "image-compressor",
    label: "Compress Images",
  },
  {
    slug: "image-to-text",
    label: "Image To Text",
  },
  {
    slug: "case-converter",
    label: "Convert Case",
  },
] as const;

export const PRIORITY_TOOL_LINKS = [
  {
    slug: "image-compressor",
    label: "Free Image Compressor",
    description: "Reduce JPG, PNG, and WebP file size, resize dimensions, and download optimized images.",
  },
  {
    slug: "image-to-text",
    label: "Image to Text Converter",
    description: "Extract editable text from screenshots, scanned notes, documents, and graphics with OCR.",
  },
  {
    slug: "case-converter",
    label: "Free Case Converter",
    description: "Change text to uppercase, lowercase, title case, sentence case, and developer formats.",
  },
  {
    slug: "color-picker",
    label: "Color Picker From Image",
    description: "Click an image pixel to get and copy its exact HEX, RGB, and HSL color values.",
  },
  {
    slug: "color-palette-generator",
    label: "Color Palette Generator",
    description: "Generate, edit, preview, and export color palettes and harmonious color schemes.",
  },
] as const;
